import Alpine from '../app/entry-setup/alpine-setup';

Alpine.start();
console.log('alpine started');
